import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { SuggestedHostsResponse } from "@/api/types";

export function useSuggestedHosts() {
  return useQuery<SuggestedHostsResponse>({
    queryKey: ["analysis", "hosts-suggested"],
    queryFn: () => api<SuggestedHostsResponse>("/api/v1/analysis/hosts-suggested"),
    // Si el backend no logra hablar con Zabbix devuelve 200 con hosts=[]
    // (degrade graceful, sin reintentos agresivos).
    retry: false,
    staleTime: 60_000,
  });
}
